import type React from "react";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <label className="flex items-center cursor-pointer">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div
          className={`w-10 h-6 rounded-full shadow-inner transition-colors ${
            checked ? "bg-primary" : "bg-gray-300"
          } ${disabled ? "opacity-50" : ""}`}
        ></div>
        <div
          className={`absolute w-4 h-4 bg-white rounded-full shadow transition-transform ${
            checked ? "translate-x-5" : "translate-x-1"
          } top-1 left-0`}
        ></div>
      </div>
      <span
        className={`ml-3 text-sm ${
          disabled ? "text-gray-500" : "text-gray-700"
        }`}
      >
        {label}
      </span>
    </label>
  );
};
